module.exports = __webpack_public_path__ + "img/query_pic.81fa87cb.jpg";